import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortComuna'
})
export class SortComunaPipe implements PipeTransform {

  transform(value: Comuna[]):Comuna[] {
    value.sort((a,b)=>(a.Nombre>b.Nombre) ? 1 : ((b.Nombre>a.Nombre)? -1 : 0))
    return value;
  }

}
